"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guidelineKeyTranslation = void 0;
exports.guidelineKeyTranslation = {
    // TODO rather use i18n after refacto
    city: 'Ville',
    decisionType: 'Type de décision',
    defendant: 'Défendeur',
    juridictionRoom: 'Chambre',
    juridictionShort: 'Appellation abrégée',
    juridictionType: 'Type de juridiction',
    jury: 'Composition de la juridiction',
    language: 'Langue',
    number: 'Numéro',
    plaintiff: 'Demandeur',
    publicationStatus: 'Statut',
    result: 'Dispositif',
    summary: 'Intitulé',
};
//# sourceMappingURL=decision.js.map